<template>
  <v-container>
    <a href="javascriptt:void(0)" @click="showDialogBox">{{
      numberWithCommas(subscribedPackage.net_price)
    }}</a>
    <v-dialog v-model="showDialog" max-width="500">
      <v-card class="pa-3 pa-md-12">
        <v-row justify="end">
          <v-btn color="primary" text @click="showDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-row>
        <v-row justify="center">
          <v-card-title class="headline primary--text"
            >Price Splitup</v-card-title
          >
        </v-row>

        <v-row justify="space-between" class="mx-2">
          <h5 class="primary--text">
            Package Price :
            {{ numberWithCommas(subscribedPackage.package_price) }} SR
          </h5>
        </v-row>
        <v-row justify="space-between" class="mx-2">
          <h5 class="primary--text">
            Discount : {{ numberWithCommas(subscribedPackage.discount) }} SR
          </h5>
        </v-row>
        <v-row justify="space-between" class="mx-2">
          <h5 class="primary--text">
            Wallet : {{ numberWithCommas(subscribedPackage.walletApplied) }} SR
          </h5>
        </v-row>

        <v-row
          justify="space-between"
          class="mx-2"
          v-if="subscribedPackage.isPromoCodeApplied"
        >
          <h5 class="primary--text">
            Promo Code :
            {{ subscribedPackage.promoCodeInfo.promoCodeDetails.promoCode }},

            {{ subscribedPackage.promoCodeInfo.promoCodeDetails.discount }}
            {{
              subscribedPackage.promoCodeInfo.promoCodeDetails.inPercentage
                ? "%"
                : "SR"
            }}
          </h5>
        </v-row>

        <v-row
          justify="space-between"
          class="mx-2"
          v-if="subscribedPackage.isPromoCodeApplied"
        >
          <h5 class="primary--text">
            Promo Code Discount :
            {{ numberWithCommas(subscribedPackage.promoCodeDiscount) }} SR
          </h5>
        </v-row>

        <v-row justify="space-between" class="mx-2">
          <h5 class="primary--text">
            Net Price :
            {{ numberWithCommas(subscribedPackage.net_price) }} SR
          </h5>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  components: {},
  props: {
    subscribedPackage: {
      require: true
    }
  },
  methods: {
    showDialogBox() {
      this.showDialog = true;
    }
  },
  created() {},
  data() {
    return {
      showDialog: false
    };
  }
};
</script>
